<script>
export let plan;
</script>
<div class="container-discount {$$props.class}">
    {#if (plan?.hasReferralDiscounts ?? false) === false}
        {#if Number.isInteger(plan.percentOff)}
            {#if plan.percentOff > 0}
                <p class="has-text-centered">
                    <span class="percent-off-tag has-text-success fw500 font-size-14 {plan.is_recommended}">
                        Ahorra {plan.percentOff}%
                    </span>
                </p>
            {/if}
        {/if}
        {:else}
            <p class="has-text-centered">
                <span class="percent-off-tag has-text-success fw500 font-size-14 {plan.is_recommended}">
                    Ahorra {plan.hasReferralDiscounts}%
                </span>
            </p>
    {/if}
</div>